export default __webpack_public_path__ + "static/media/ic-emptycoupon.2dff06be.svg";